module.exports = __webpack_public_path__ + "cc5d2818bf1caced199d3b162a05dfb7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/goldencity21.jpg
// module id = 490
// module chunks = 0